/** @todo PT-2191 : Update response  */
export type LoginResponse = {
  data: {
    customer: {
      id: number;
      email: string;
      acceptsMarketing: false;
      createdAt: number;
      updatedAt: string;
      firstName: string;
      lastName: string;
      ordersCount: number;
      state: string;
      totalSpent: string;
      lastOrderId: number;
      note: any;
      verifiedEmail: true;
      multipassIdentifier: any;
      taxExempt: boolean;
      phone: any;
      tags: string;
      lastOrderName: string;
      currency: string;
      addresses: Array<Address>;
      acceptsMarketingUpdatedAt: string;
      marketingOptInLevel: any;
      taxExemptions: Array<any>;
      adminGraphqlApiId: string;
      defaultAddress: Address;
    };
    referalToken: string;
    migrate: boolean;
  };
  error: { type: string } | null;
};

type Address = {
  id: number;
  customerId: number;
  firstName: string;
  lastName: string;
  company: string;
  address1: string;
  address2: string;
  city: string;
  province: string;
  country: string;
  zip: string;
  phone: string;
  name: string;
  provinceCode: string;
  countryCode: string;
  countryName: string;
  default: boolean;
};

/** Assertion function for auth error */
export function isAuthError(error: any): error is LoginResponse['error'] {
  return error.type !== undefined;
}

import { AxiosError } from 'axios';

interface WrongShopResponse {
  shop_url: string;
}

/**
 * Assertion function to check if the error is an Axios error with wrong shop response
 * @param error - The error to check
 * @returns True if the error is an Axios error with wrong shop response structure
 */
export function isWrongShopError(
  error: unknown
): error is AxiosError<WrongShopResponse> {
  try {
    const response = (error as AxiosError<WrongShopResponse>).response?.data;

    return (
      typeof response === 'object' &&
      response !== null &&
      'shop_url' in response &&
      typeof response.shop_url === 'string'
    );
  } catch (error) {
    return false;
  }
}
